<!--<contact-common-search [sendMailInfo]="sendMailInfo"></contact-common-search>-->
<bulk-contact-common *ngIf="user" (sendMailInfo)="sendMailInfo = $event;" [user]=user [roleFeaturePermissions]="roleFeaturePermissions"></bulk-contact-common>
